<script>
    import { createEventDispatcher } from "svelte";
    import Button from "@smui/button";
    import Paper, { Title, Content } from "@smui/paper";
    import Flex from "svelte-flex";
    import DataTable, { Body, Row, Cell } from "@smui/data-table";
    import { Icon } from "@smui/icon-button";
    import { mdiMagnify, mdiFileExcel, mdiPencil } from "@mdi/js";
    import { _ } from "svelte-i18n";
    import CircularProgress from "@smui/circular-progress";

    import { isActionEnabled } from "../lib/Functions";

    const dispatch = createEventDispatcher();

    export let week;
    export let apiCallProcessing = false;

    $: editDisabled = !(
        isActionEnabled("supp_amendments", "insert", week.status) ||
        isActionEnabled("supp_amendments", "edit", week.status) ||
        isActionEnabled("supp_amendments", "delete", week.status)
    );
    $: uploadDisabled = !isActionEnabled("supp_amendments", "insert", week.status);

    let tableRows = [
        { key: "asTotalLines", label: "total_lines" },
        { key: "asConfirmedLines", label: "confirmed_lines" },
        { key: "asRejectedLines", label: "rejected_lines", extraClass: "border-left" },
        { key: "asPendingLines", label: "pending_lines" },
    ];
</script>

<section>
    <Paper data-qa={"dashboard-board-am-summary-card-" + week.id + "-" + week.status} square elevation="0" class="pa-0 ma-0">
        <Title class="pt-2 pl-2 pr-2 tescoblue-text">
            <Flex direction="row" align="center" justify="between" class="gap-1">
                <div>{$_("amendments")}</div>
                <Flex direction="row" class="mr-2 gap-1">
                    <div title={$_("upload")}>
                        <Button
                            data-qa={"dashboard-board-am-summary-card-upload-btn-" + week.id + "-" + week.status}
                            disabled={uploadDisabled}
                            variant="outlined"
                            class={uploadDisabled ? " grey-text white-grey-outlined" : " tescoblue-text white-tescoblue-outlined"}
                            on:click={() => dispatch("uploadASData", { id: week.id, year: week.tescoYear })}
                        >
                            <Icon tag="svg" viewBox="0 0 24 24" class="pr-0 pl-1">
                                <path fill="currentColor" d={mdiFileExcel} />
                            </Icon>
                            {$_("upload")}
                        </Button>
                    </div>
                    {#if editDisabled}
                        <div title={$_("view")}>
                            <Button
                                data-qa={"dashboard-board-am-summary-card-view-btn-" + week.id + "-" + week.status}
                                class="pl-4 pr-4 tescoblue-text white-tescoblue-outlined "
                                on:click={() => dispatch("editASWeek", { id: week.id, year: week.tescoYear })}
                            >
                                <Icon tag="svg" viewBox="0 0 24 24" class="pr-0 pl-1">
                                    <path fill="currentColor" d={mdiMagnify} />
                                </Icon>
                                {$_("view")}
                            </Button>
                        </div>
                    {:else}
                        <div title={$_("edit")}>
                            <Button
                                data-qa={"dashboard-board-am-summary-card-edit-btn-" + week.id + "-" + week.status}
                                class="pl-4 pr-4 {editDisabled ? ' grey-text white-grey-outlined ' : ' tescoblue-text white-tescoblue-outlined '}"
                                on:click={() => dispatch("editASWeek", { id: week.id, year: week.tescoYear })}
                            >
                                <Icon tag="svg" viewBox="0 0 24 24" class="pr-0 pl-1">
                                    <path fill="currentColor" d={mdiPencil} />
                                </Icon>
                                {$_("edit")}
                            </Button>
                        </div>
                    {/if}
                </Flex>
            </Flex>
        </Title>
        <Content class="ma-2 pb-2">
            <Flex direction="row" class="w-100 gap-2" justify="between">
                <DataTable class="summary summary-border-fix tescoblue-border w-100">
                    <Body>
                        {#each tableRows as row}
                            <Row class={row.extraClass ? row.extraClass : ""}>
                                <Cell class="text-label datatable-header pl-1 pr-2">{$_(row.label)}</Cell>
                                <Cell class="text-right pl-2 pr-2" style="min-width:7rem">
                                    {#if apiCallProcessing}
                                        <CircularProgress indeterminate style="height: 24px; width: 24px;" />
                                    {:else}
                                        {week[row.key]}
                                    {/if}
                                </Cell>
                            </Row>
                        {/each}
                    </Body>
                </DataTable>
            </Flex>
        </Content>
    </Paper>
</section>
